<template>
  <div class="user_con_main">
    <div class="user_contop">
      <div class="user_contopl">
        <img src="../../assets/images/img2/loginoff.png" class="user_avater" />
        <div>
          <div class="flex_ali">
            <span>{{ userinfo.nickname }}</span>
            <!-- 非会员 -->
            <router-link to="/viphub"
              ><img
                src="../../assets/images/img2/user_vipoff.png"
                class="user_state"
                v-if="
                  userrich.isvalidsvip == '0' && userrich.isvalidvip == '0'
                "
            /></router-link>
            <!-- 普通会员 -->
            <router-link to="/viphub" v-if="userrich.isvalidvip == '1'"
              ><div class="user_vipstate">
                <img src="../../assets/images/img2/user_vip.png" alt="" />
                <span>{{ userrich.viptime.split(" ")[0] }}</span>
              </div></router-link
            >
            <!-- 超级会员 -->
            <router-link to="/viphub" v-if="userrich.isvalidsvip == '1'"
              ><div class="user_vipstate user_vipstate2">
                <img src="../../assets/images/img2/user_svip.png" alt="" />
                <span>{{ userrich.sviptime.split(" ")[0] }}</span>
              </div></router-link
            >
          </div>
          <p>ID: {{ userinfo.id }}</p>
        </div>
      </div>
      <div class="flex_ali_h">
        <div class="user_contopr" v-if="userrich.isvalidsvip == '1'">
          <p>{{remaining}}</p>
          <p>剩余字符数</p>
        </div>
        <!-- <div class="user_contopr">
          <p>{{userrich.jb}}</p>
          <p>我的金币</p>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["showlogin", "userinfo", "userrich"]),
  },
  data() {
    return {
      user_name: "",
      editor_state: false, //编辑状态
      remaining:0,//用户剩余字符数
    };
  },
  mounted() {
    setTimeout(() => {
      this.user_name = this.$store.state.userinfo.nickname;
    }, 1000);
    this.getStringNum()
  },
  methods: {
    // 查询字符数
    getStringNum(){
      let self = this;
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qrytextnum;
      if(this.userrich && this.userrich.isvalidsvip == '1' && this.userrich.sviptype.length>1){
        url =
        self.$store.state.app_api + self.$store.state.app_url.qrytextnumv2;
      }
      this.$request.postHttp({}, url, (decData) => {
        console.log("===",decData);
        self.remaining = decData.model.remaining
      });
    },
    // 取消编辑
    cancelUpInfo() {
      this.user_name = this.$store.state.userinfo.nickname;
      this.editor_state = false;
    },
    // 绑定手机号
    bindPhone() {
      this.$store.commit("setIsBind", 1);
      this.$store.commit("setShowLogin", true);
    },
    // 更新用户信息
    updataUserInfo() {
      let self = this;
      if (this.user_name == "") {
        this.$message({
          message: "用户名不能为空",
          type: "warning",
          offset: 120,
        });
        return;
      }
      let json = {
        nickname: this.user_name,
      };
      let url =
        this.$store.state.base_api + this.$store.state.base_url.updateuserinfo;
      this.$request.postHttp(json, url, (decData) => {
        console.log(decData);
        if (decData.rc == "0") {
          self.$message({
            message: "修改成功",
            type: "success",
            offset: 120,
          });
          self.$globalFun.getUserInfo(self);
          self.editor_state = false;
        } else {
          self.$message({
            message: "修改失败",
            type: "warning",
            offset: 120,
          });
        }
      });
    },
  },
};
</script>
<style scoped>
@import url("../../assets/css/user.css");
</style>



// WEBPACK FOOTER //
// src/view/user/user_con.vue